module.exports = __webpack_public_path__ + "static/media/touch-screen.8b4049df.svg";